import { bindable, ViewResources, View, noView } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import { AdornerService } from "../../services/basic/adorner.service";
import { AdornerModel } from "./comp-adorner.models";

@autoinject
@transient()
@noView()
export class CompAdorned {

    @bindable()
    public context: any;

    @bindable()
    public view: string | View;

    @bindable()
    public autoWidth: boolean;

    @bindable()
    public adornerDirection: 'auto' | 'up' | 'down' = 'auto';

    public html: string | View;

    public adorner: any;

    constructor(private adornerService: AdornerService, private element: Element, private resourcesExisting: ViewResources) { }

    attached() {
        this.attachElement();
    }

    contextChanged() {
        this.attachElement();
    }


    viewChanged() {
        if (this.view && typeof this.view == "string") {
            this.html = this.view.replace(/<template>/g, "").replace(/<\/template>/g, "");
        } else if (this.view instanceof View) {
            this.html = this.view;
        }
        this.attachElement();
    }

    elementChanged() {
        this.attachElement();
    }

    attachElement() {
        if (this.context && this.html && this.element) {
            if (this.adorner) {
                this.adornerService.remove(this.adorner);
            }

            this.adorner = new AdornerModel(this.context, this.html, this.element, this.autoWidth, this.adornerDirection, this.resourcesExisting);
            this.adornerService.add(this.adorner);
        }
    }

    detached() {
        this.adornerService.remove(this.adorner);
    }
}
